export default __webpack_public_path__ + "static/media/moreIcon.0679cec3.svg";